import AppLayout from "../../components/AppLayout";
import useWhatsappTemplasteAdmin from "../../hooks/pages/admin/useWhatsappTemplateAdmin";
import TableBotsTemplates from "../../components/tables/TableBotsTemplates";

const WhatsAppTemplatesAdmin = () => {

    const {
        isLoading,
        templatesData,
        flattenTemplates,
        selectedTemplateFiles,
        setSelectedTemplateFiles,
        createTemplate,
        trackerData
    } = useWhatsappTemplasteAdmin();

    const getTemplateData = (templatesData) => {
        if (templatesData) {
            return flattenTemplates(templatesData);
        }
        return ([]);
    }

    return (
        <AppLayout
            isLoading={isLoading}
            title="Panel de Administrador"
            tabType="admin"
            tab={2}
        >
            <div className="p-2 pt-0 mb-3">
                <TableBotsTemplates
                    data={getTemplateData(templatesData)}
                    selectedTemplateFiles={selectedTemplateFiles}
                    setSelectedTemplateFiles={setSelectedTemplateFiles}
                    addTemplate={createTemplate}
                    trackerData={trackerData}
                />
            </div>
        </AppLayout>
    );
};

export default WhatsAppTemplatesAdmin;
